<template>
  <div>
    <div class="confirmBox">
      <strong class="tit">서비스 가입 내역이 존재하지 않습니다.</strong>
    </div>
    <div class="btnBox fullBtn">
      <a class="btnL" @click="$router.push('/')">BMW ServiceCare+ 안내</a>
    </div>
  </div>
</template>


<script>
  export default {};
</script>